module.exports = __webpack_public_path__ + "static/animation-talk-person01-0dc50d904e02873046dce879aaf0f8eb.png";